<template>
  <div>
    <div class="vacancy-card-new__employer">
      <div class="vacancy-card-new__employer-logo-wrap  _no-link">
        <v-lazy-image
          v-if="employerProfile && employerProfile.company_logo"
          use-picture
          :src="employerProfile.company_logo"
          :title="createTitleMixin(employerProfile.name)"
          :alt="createAltMixin(employerProfile.name)"
        >
          <source
            type="image/webp"
            :srcset="employerProfile.company_logo_webp"
          >
        </v-lazy-image>

        <BaseSvg
          v-else
          name="ico-avatar"
        />
      </div>

      <div class="vacancy-card-new__employer-top  _no-link">
        <div class="vacancy-card-new__employer-label">Вакансия от</div>

        <div
          v-if="false"
          class="vacancy-card-new__rating"
        >
          <div class="vacancy-card-new__rating-stars">
            <BaseSvg
              v-for="(star) in 5"
              name="ico-star"
              :key="star"
              :class="{ _active: true }"
            />
          </div>

          <BaseHelp
            class="vacancy-card-new__side-help"
            value="Some text by props value"
          />
        </div>
      </div>

      <div class="vacancy-card-new__employer-name  _no-link">
        <abbr v-if="employerProfile && (employerProfile.short_name || employerProfile.name)">{{employerProfile && (employerProfile.short_name || employerProfile.name)}}</abbr>
        <abbr v-else>{{$tVacancy('No name')}}</abbr>
        <BaseSvg
          class="vacancy-card-new__employer-name-badge"
          name="ico-check-outline"
        />
      </div>
    </div>

    <div class="vacancy-card-new__side-links  _no-link">
      <router-link-modified
        class="vacancy-card-new__side-link inline-link"
        tag="div"
        :to="{
          name: 'company-info',
          params: {
            companySlug: employerProfile.slug || employerProfile.id
          }
        }"
      >
        <span>{{ $tVacancy('Dossier') }}</span>&nbsp;
        <BaseSvg
          class="_arrow"
          name="ico-arrow-light"
        />
      </router-link-modified>

      <router-link-modified
        class="vacancy-card-new__side-link inline-link"
        :to="{
          name: 'vacancies',
          query: {
            customer_id: employer.id
          }
        }"
      >
        <span>{{ $tVacancies('All company vacancies') }}</span>&nbsp;
        <BaseSvg
          class="_arrow"
          name="ico-arrow-light"
        />
      </router-link-modified>

      <router-link-modified
        v-if="false"
        class="vacancy-card-new__side-link inline-link"
        to="#"
        tag="a"
      >
        <span>{{ $tVacancy('Reviews') }}</span>&nbsp;
        <BaseSvg
          class="_arrow"
          name="ico-arrow-light"
        />
      </router-link-modified>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'VacancyCardEmployer',

    props: {
      employer: {
        type: Object,
        required: true
      },
      rating: {
        type: Boolean
      }
    },
    computed: {
      employerProfile() {
        return this.employer.employerProfile || {}
      }
    }
  };
</script>
